export const secondsToMinAndSec = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const secondsLeft = seconds % 60
  return (minutes < 10 ? '0' + minutes : minutes) + ':' + (secondsLeft < 10 ? '0' + secondsLeft : secondsLeft)
}

export const secondsToHM = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  var secondsLeft = seconds % 3600
  const minutes = Math.floor(secondsLeft / 60)
  secondsLeft = seconds % 60
  return ((hours > 0 ? hours + 'h' : '') + ' ' + (minutes > 0 ? minutes + 'm' : '0m')).trim()
}

export const secondsToHMS = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  var secondsLeft = seconds % 3600
  const minutes = Math.floor(secondsLeft / 60)
  secondsLeft = seconds % 60
  return (hours > 0 ? (hours < 10 ? '0' + hours + ':' : hours + ':') : '') +
    (minutes > 0 ? (minutes < 10 ? '0' + minutes + ':' : minutes + ':') : '00:') +
    (secondsLeft > 0 ? (secondsLeft < 10 ? '0' + secondsLeft : secondsLeft) : '00')
}

export const getEndTime = (startHour, startMinute, durationInSeconds) => {
  startHour = parseInt(startHour)
  startMinute = parseInt(startMinute)
  const time = new Date()
  time.setSeconds(0)
  time.setHours(0)
  time.setMilliseconds(0)
  time.setMinutes(parseInt(startMinute))
  time.setHours(parseInt(startHour))
  time.setSeconds(durationInSeconds)
  const minutes = time.getMinutes()
  const hours = time.getHours()
  return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes)
}



// WEBPACK FOOTER //
// ./src/utils/numberUtils.js